import Image from "next/image";
import qrImage from "@/assets/images/QRimage/AlfaQRNew.jpeg";
import { GET_APP_LABEL, SCAN_TO_DOWNLOAD_LABEL } from "./getOurAppConfig";
import "./GetOurApp.scss";

export default function GetOurAppButton() {
  return (
    <div className="get-our-app-trigger">
      <span className="get-our-app-trigger-qr">
        <Image
          src={qrImage}
          alt="Scan the QR and get the AlfaMall App"
          width={40}
          height={40}
        />
      </span>
      <span className="get-our-app-trigger-text">
        <span className="get-our-app-trigger-title">{GET_APP_LABEL}</span>
        <span className="get-our-app-trigger-subtitle">
          {SCAN_TO_DOWNLOAD_LABEL}
        </span>
      </span>
    </div>
  );
}
